import { faIcon } from "@utils/faIcon"

import { ColorBadge } from "@atoms/index"

import { ObjectStatusBadgeProps } from "./ObjectStatusBadge.types"
import { getObjectStatusStyle } from "./ObjectStatusBadge.utils"

export default function ObjectStatusBadge(props: ObjectStatusBadgeProps) {
    const { status, statusLabelOverride, size = "md" } = props
    const { colorScheme, icon, iconRotation } = getObjectStatusStyle(props)

    return (
        <ColorBadge
            variant="icon"
            colorScheme={colorScheme}
            icon={faIcon({ name: icon, style: "solid" })}
            iconRotation={iconRotation}
            size={size}
        >
            {statusLabelOverride ?? status}
        </ColorBadge>
    )
}
